import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import * as vars from '../../constants/constants';
import { show, hide } from '../../actions/ActivityIndicatorActions';
import { checkAccess } from '../../actions/WelcomeActions';
import axios from 'axios';
import { Row, Col} from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { console_log,parseQueryString, getSubdomain,getUid } from '../../utils/helper';
import { config } from '../../constants/domainConfig';
import { showMessage } from '../../actions/FlashMessageActions';
import Loader from './../loader/loader';
import { messages } from '../../constants/messages';



class ChangePassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isValid: false,
            errorMessage: '',
            domain: window.location.host,
            msisdnNotFound: false,
            reason: '',
            password: '',
            cpassword: '',
            token : parseQueryString(this.props.location.search)['token'],
            submitted: false,
            loading: false,
            error: {
                password:false,
                cpassword:false,
                token : false
            },
            regURL: `/register`
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.isValid = this.isValid.bind(this);
    }

    componentWillMount(){
    }
    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }
    isValid(){

        let { password, cpassword, error} = this.state;
        if(!(password)){
            error.password=true;
           this.setState({
               error:error
           })
        }else{
            error.password=false;
           this.setState({
               error:error
           })
        }

        if(!(cpassword)){
            error.cpassword=true;
            this.setState({
                error:error
            })
        }else{
            error.cpassword=false;
           this.setState({
               error:error
           })
        }

        if(password != cpassword) {
            // Confirm Password does not match.
            this.props.showMessage({
                message: 'Confirme que a Palavra-passe não corresponde.',
                type: false
            });
            return false
        }
        
        if(error.password || error.token){
            return false
        }
       
        return true
    }
    handleSubmit(e) {
        e.preventDefault();
        const {token,uid}=this.props.match.params;
        this.setState({ submitted: true });
        const { password,    returnUrl } = this.state;
        if(this.isValid()) {
            this.callChangePassword({
                password: password,
                token : token
            });
        }
    }
    callChangePassword(input) {
        this.setState({
            loading:true
        })
            axios.post(vars.BASE_API_URL + `/change_password`,{ 
                password: input.password,
                token: input.token
            })
            .then((response) => {
                this.setState({
                    loading:false
                })
                if (response.data.success && response.data.data[0] == 1) {
                    // Your password has been reset successfully!
                    this.props.showMessage({
                        message: 'A sua palavra-passe foi redefinida com sucesso!',
                        type: true
                    });
                    // let uidData= JSON.parse(sessionStorage.getItem('uid'));
                    this.setState({password : 0,cpassword : 0})
                    // this.props.history.push('/loginWithEmailId/?uid=' + uidData);
                }
                else {
                    // This password reset link has expired. Please try again ...
                    this.props.showMessage({
                        message: 'Esta ligação para redefinir a palavra-passe caducou. Por favor, tente de novo...',
                        type: false
                    });
                    
                    //this.props.history.push("/restricted");
                }
            })
            .catch((error) => {
                this.setState({
                    loading:false
                })
                console.log(error);
                // this.props.history.push("/restricted");
            })
    }

    render() {
            let passwordLabel = 'Password';
            let cpasswordLabel = 'Password';
            if(config.domain == 'pt') {
                passwordLabel = 'Senha';
                cpasswordLabel = 'Confirme a Senha';
            }
            const { password, cpassword, submitted, loading, error,regURL } = this.state;
            const {token,uid}=this.props.match.params
            return (
                <div className="login animated fadeIn">
                    <Row className="justify-content-center">
                        <Col>
                            <Row className="login-page-header">
                                <div className="login-page-header-child">
                                    <img className="login-page-logo" src="./img/logo.png" alt="Mobio360" width="125px" />
                                </div>
                            </Row>
                            <form name="form" onSubmit={this.handleSubmit}>
                            <Row className="login-page-content">
                                <h1>
                                    <FormattedMessage id="reset-password-title"
                                        defaultMessage="Reset Your Password"
                                    />
                                </h1>
                                <p>
                                    <FormattedMessage id="reset-password-head"
                                        defaultMessage="Enter a new password for your account"
                                    />
                                </p>

                                <div className="login-page-mobile_num">
                                    <input type="password" name="password" placeholder={passwordLabel} value={password} onChange={this.handleChange} className="LoginRoute-number" />
                                    {error.password && <span className="error-message">
                                         <FormattedMessage id="password-required"
                                            defaultMessage="Password is required."
                                            />
                                    </span>}

                                    <input type="password" name="cpassword" placeholder={cpasswordLabel} value={cpassword} onChange={this.handleChange}  className="LoginRoute-number" />
                                    {/* {error.password && <span className="error-message">
                                        <FormattedMessage id="password-required"
                                            defaultMessage="Password is required."
                                            />
                                        </span>} */}

                                    
                                    <button type="submit"  disabled={loading} className="LoginRoute-button">
                                    {loading ?<Loader/> :
                                         <FormattedMessage id="submit"
                                         defaultMessage="Submit"
                                     />
                                     }
                                       
                                    </button>
                                </div>
                            </Row>
                            </form>
                        </Col>
                                <Row className="login-page-content ">
                                    <Link className="reg-link" to={`/loginWithEmailId/?uid=${uid}`}>
                                        <FormattedMessage id="login"
                                            defaultMessage="Login"
                                        />
                                    </Link>
                                </Row>
                        <Col>

                        </Col>
                    </Row>
                </div>
            );
        
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.AuthenticationReducer,
        loader: state.ActivityIndicatorReducer,
        access: state.WelcomeReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        checkAccess,
        show,
        hide,
        showMessage,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);



// WEBPACK FOOTER //
// ./src/components/Login/ChangePassword.js